import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';
import { STORE_TYPES } from '@/store/modules/types';

import HeaderMobile from '@/components/header/HeaderMobile.vue';
import Header from '@/components/header/Header.vue';
import Sidebar from '@/components/shared/Sidebar.vue';

// Auth
import SignupPage from '@/components/auth/SignUpPage.vue';
import SigninPage from '@/components/auth/SignInPage.vue';
import RegistrationFinish from '@/components/auth/ConfirmationPage.vue';
import ChangePasswordPage from '@/components/profile/ChangePassword.vue';
import ForgetPass from '@/components/auth/ForgetPass.vue';
import PasswordResetFinish from '@/components/auth/PasswordResetFinish.vue';
import PassThrough from '@/components/auth/PassThrough.vue';
import WelcomePage from '@/components/welcome/WelcomePage.vue';
import WelcomePageSidebar from '@/components/welcome/Sidebar.vue';

// Profile
import ProfilePage from '@/components/profile/ProfilePage.vue';
import ProfileInfoPage from '@/components/profile/ProfileInfo.vue';
import ProfileEditPage from '@/components/profile/ProfileEdit.vue';

// CDN
// import DashboardPage from '../components/dashboard/dashboard.vue';
import CDNRoutePage from '@/components/cdn/RoutePage.vue';
import EndpointsPage from '@/components/cdn/endpoint/EndpointPage.vue';
import EndpointListPage from '@/components/cdn/endpoint/EndpointList.vue';
import EndpointDetailPage from '@/components/cdn/endpoint/EndpointDetail.vue';
import EndpointEditPage from '@/components/cdn/endpoint/EndpointEdit.vue';

// File Transcoding
import FileTranscodingRoutePage from '@/components/transcoding/file/RoutePage.vue';
import FileTranscodingDashboardPage from '@/components/transcoding/file/dashboard/DashboardPage.vue';
import FileTranscodingJobsPage from '@/components/transcoding/file/jobs/JobsPage.vue';
import FileTranscodingJobListPage from '@/components/transcoding/file/jobs/JobList.vue';
import FileTranscodingJobDetailPage from '@/components/transcoding/file/jobs/DetailPage.vue';
import FileTranscodingNewJobPage from '@/components/transcoding/file/jobs/CreateJob.vue';
import FileTranscodingJobLogPage from '@/components/transcoding/file/jobs/LogPage.vue';
import WatchFolderRoutePage from '@/components/transcoding/file/watchfolder/RoutePage.vue';
import WatchFolderListPage from '@/components/transcoding/file/watchfolder/WFList.vue';
import WatchFolderDetailPage from '@/components/transcoding/file/watchfolder/DetailPage.vue';
import WatchFolderEditPage from '@/components/transcoding/file/watchfolder/CreateWF.vue';

// Live Transcoding
import LiveTranscodingRoutePage from '@/components/transcoding/live/RoutePage.vue';
import LiveTranscodingDashboardPage from '@/components/transcoding/live/dashboard/DashboardPage.vue';
import LiveTranscodingNewJobPage from '@/components/transcoding/live/jobs/CreateJob.vue';
import LiveTranscodingJobsPage from '@/components/transcoding/live/jobs/JobsPage.vue';
import LiveTranscodingJobListPage from '@/components/transcoding/live/jobs/JobList.vue';
import LiveTranscodingJobDetailPage from '@/components/transcoding/live/jobs/DetailPage.vue';
import LiveTranscodingDistributionPage from '@/components/transcoding/live/distributions/RoutePage.vue';
import LiveTranscodingDistributionListPage from '@/components/transcoding/live/distributions/DistributionList.vue';
import LiveTranscodingDistributionDetailPage from '@/components/transcoding/live/distributions/DetailPage.vue';
import LiveTranscodingCreateDistributionPage from '@/components/transcoding/live/distributions/CreateDistribution.vue';

// DVR
import DVRRoutePage from '@/components/dvr/RoutePage.vue';
import DVRListPage from '@/components/dvr/DVRList.vue';
import DVRNewPage from '@/components/dvr/CreateDVR.vue';
import DVRDetailPage from '@/components/dvr/DetailPage.vue';


// Transcoding Profiles
const EncodingProfilePage = (resolve) => {
  require.ensure(['../components/transcoding/profile/ProfilePage.vue'], () => resolve(require('../components/transcoding/profile/ProfilePage.vue')));
};
const EncodingProfileListPage = (resolve) => {
  require.ensure(['../components/transcoding/profile/ProfileList.vue'], () => resolve(require('../components/transcoding/profile/ProfileList.vue')));
};
const EncodingProfileDetailPage = (resolve) => {
  require.ensure(['../components/transcoding/profile/ProfileDetail.vue'], () => resolve(require('../components/transcoding/profile/ProfileDetail.vue')));
};
const EncodingProfileEditPage = (resolve) => {
  require.ensure(['../components/transcoding/profile/ProfileEdit.vue'], () => resolve(require('../components/transcoding/profile/ProfileEdit.vue')));
};

// CDN
const CDNDashboardPage = (resolve) => {
  require.ensure(['../components/cdn/dashboard/DashboardPage.vue'], () => resolve(require('../components/cdn/dashboard/DashboardPage.vue')));
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: (to) => {
      store.dispatch('fetchProject');
      const currentProject = store.getters.projectCode;
      if (!currentProject) {
        return 'welcome';
      }
      return currentProject;
    },
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignupPage,
    meta: { onlyGuestUser: true },
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SigninPage,
    meta: { onlyGuestUser: true },
  },
  {
    path: '/confirm/:code',
    component: RegistrationFinish,
    meta: { onlyGuestUser: true },
  },
  {
    path: '/forget-pass',
    component: ForgetPass,
    name: 'ForgetPass',
    meta: { onlyGuestUser: true },
  },
  {
    path: '/pass-reset-finish/:code',
    component: PasswordResetFinish,
    name: 'PasswordResetFinish',
    meta: { onlyGuestUser: true },
  },
  {
    path: '/pass-through/:token',
    component: PassThrough,
    name: 'PassThrough',
  },
  {
    path: '/welcome',
    components: {
      default: WelcomePage,
      sidebar: WelcomePageSidebar,
    },
    name: 'Welcome',
    meta: { onlyAuthUser: true },
    beforeEnter: (to, from, next) => {
      store.dispatch('fetchProject');
      const currentProject = store.getters.projectCode;
      if (currentProject) {
        next({ path: '/' });
      } else {
        next();
      }
    },
  },
  {
    path: '/cdn',
    components: {
      default: CDNRoutePage,
      headerMobile: HeaderMobile,
      header: Header,
      sidebar: Sidebar,
    },
    children: [
      {
        name: 'CDNDashboard',
        path: '',
        component: CDNDashboardPage,
        meta: { onlyAuthUser: true },
      },
      {
        path: 'endpoints',
        component: EndpointsPage,
        children: [
          {
            name: 'EndpointListPage',
            path: '',
            component: EndpointListPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'EndpointNewPage',
            path: 'new',
            component: EndpointEditPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'EndpointDetailPage',
            path: ':id',
            component: EndpointDetailPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'EndpointEditPage',
            path: ':id/edit',
            component: EndpointEditPage,
            meta: { onlyAuthUser: true },
          },
        ],
      },
    ],
  },
  {
    path: '/file-transcoding',
    components: {
      default: FileTranscodingRoutePage,
      headerMobile: HeaderMobile,
      header: Header,
      sidebar: Sidebar,
    },
    children: [
      {
        name: 'FileTranscodingDashboard',
        path: '',
        component: FileTranscodingDashboardPage,
        meta: { onlyAuthUser: true },
      },
      {
        path: 'jobs',
        component: FileTranscodingJobsPage,
        children: [
          {
            name: 'FileTranscodingJobList',
            path: '',
            component: FileTranscodingJobListPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'FileTranscodingNewJobPage',
            path: 'new',
            component: FileTranscodingNewJobPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'FileTranscodingJobDetailPage',
            path: ':id',
            component: FileTranscodingJobDetailPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'FileTranscodingJobLogPage',
            path: ':id/log',
            component: FileTranscodingJobLogPage,
            meta: { onlyAuthUser: true },
          },
        ],
      },
      {
        path: 'profiles',
        component: EncodingProfilePage,
        children: [
          {
            name: 'EncodingProfileListPage',
            path: '',
            component: EncodingProfileListPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'EncodingProfileNewPage',
            path: 'new',
            component: EncodingProfileEditPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'EncodingProfileDetailPage',
            path: ':id',
            component: EncodingProfileDetailPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'EncodingProfileEditPage',
            path: ':id/edit',
            component: EncodingProfileEditPage,
            meta: { onlyAuthUser: true },
          },
        ],
      },
      {
        path: 'watchfolders',
        component: WatchFolderRoutePage,
        children: [
          {
            name: 'WatchFolderListPage',
            path: '',
            component: WatchFolderListPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'WatchFolderNewPage',
            path: 'new',
            component: WatchFolderEditPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'WatchFolderDetailPage',
            path: ':id',
            component: WatchFolderDetailPage,
            meta: { onlyAuthUser: true },
          },
        ],
      },
    ],
  },
  {
    path: '/live-transcoding',
    components: {
      default: LiveTranscodingRoutePage,
      headerMobile: HeaderMobile,
      header: Header,
      sidebar: Sidebar,
    },
    children: [
      {
        name: 'LiveTranscodingDashboard',
        path: '',
        component: LiveTranscodingDashboardPage,
        meta: { onlyAuthUser: true },
      },
      {
        path: 'jobs',
        component: LiveTranscodingJobsPage,
        children: [
          {
            name: 'LiveTranscodingNewJobPage',
            path: 'new',
            component: LiveTranscodingNewJobPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'LiveTranscodingJobDetailPage',
            path: ':id',
            component: LiveTranscodingJobDetailPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'LiveTranscodingJobMetaPage',
            path: ':id/meta',
            component: LiveTranscodingJobDetailPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'LiveTranscodingJobEditPage',
            path: ':id/edit',
            component: LiveTranscodingNewJobPage,
            meta: { onlyAuthUser: true },
          },
        ],
      },
      {
        path: 'distributions',
        component: LiveTranscodingDistributionPage,
        children: [
          {
            name: 'DistributionListPage',
            path: '',
            component: LiveTranscodingDistributionListPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'DistributionNewPage',
            path: 'new',
            component: LiveTranscodingCreateDistributionPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'DistributionDetailPage',
            path: ':id',
            component: LiveTranscodingDistributionDetailPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'DistributionEditPage',
            path: ':id/edit',
            component: LiveTranscodingCreateDistributionPage,
            meta: { onlyAuthUser: true },
          },
        ],
      },
      {
        path: 'profiles',
        component: EncodingProfilePage,
        children: [
          {
            name: 'LiveEncodingProfileListPage',
            path: '',
            component: EncodingProfileListPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'LiveEncodingProfileNewPage',
            path: 'new',
            component: EncodingProfileEditPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'LiveEncodingProfileDetailPage',
            path: ':id',
            component: EncodingProfileDetailPage,
            meta: { onlyAuthUser: true },
          },
          {
            name: 'LiveEncodingProfileEditPage',
            path: ':id/edit',
            component: EncodingProfileEditPage,
            meta: { onlyAuthUser: true },
          },
        ],
      },
    ],
  },
  {
    path: '/profile',
    components: {
      default: ProfilePage,
      headerMobile: HeaderMobile,
      header: Header,
      sidebar: Sidebar,
    },
    children: [
      {
        name: 'ProfileInfoPage',
        path: '',
        component: ProfileInfoPage,
        meta: { onlyAuthUser: true },
      },
      {
        name: 'ProfileEditPage',
        path: 'edit',
        component: ProfileEditPage,
        meta: { onlyAuthUser: true },
      },
      {
        name: 'ChangePasswordPage',
        path: 'pass-change',
        component: ChangePasswordPage,
        meta: { onlyAuthUser: true },
      },
    ],
  },
  {
    path: '/dvr',
    components: {
      default: DVRRoutePage,
      headerMobile: HeaderMobile,
      header: Header,
      sidebar: Sidebar,
    },
    children: [
      {
        name: 'DVRListPage',
        path: '',
        component: DVRListPage,
        meta: { onlyAuthUser: true },
      },
      {
        name: 'DVRNewPage',
        path: 'new',
        component: DVRNewPage,
        meta: { onlyAuthUser: true },
      },
      {
        name: 'DVRDetailPage',
        path: ':id',
        component: DVRDetailPage,
        meta: { onlyAuthUser: true },
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes,
});

router.beforeEach((to, from, next) => {
  store.dispatch('setDefaultLocale', 'en');
  store.dispatch('tryAutoLogin')
    .then(() => {
      store.dispatch('fetchProject');
      const { isAuthenticated } = store.getters;
      if (isAuthenticated && to.meta.onlyGuestUser) {
        next({ path: '/' });
      } else if (!isAuthenticated && to.meta.onlyAuthUser) {
        next({ name: 'SignIn' });
      } else {
        next();
      }
    })
    .catch(() => {
      next({ name: 'SignIn' });
    });
});

router.afterEach((to) => {
  if (to.path.startsWith('/cdn') && store.getters.projectCode !== STORE_TYPES.PROJECT_CODE.CDN) {
    store.dispatch('changeProject', STORE_TYPES.PROJECT_CODE.CDN);
  }
  if (to.path.startsWith('/live-transcoding') && store.getters.projectCode !== STORE_TYPES.PROJECT_CODE.LIVE_TRANSCODING) {
    store.dispatch('changeProject', STORE_TYPES.PROJECT_CODE.LIVE_TRANSCODING);
  }
  if (to.path.startsWith('/file-transcoding') && store.getters.projectCode !== STORE_TYPES.PROJECT_CODE.FILE_TRANSCODING) {
    store.dispatch('changeProject', STORE_TYPES.PROJECT_CODE.FILE_TRANSCODING);
  }
  if (to.path.startsWith('/dvr') && store.getters.projectCode !== STORE_TYPES.PROJECT_CODE.DVR) {
    store.dispatch('changeProject', STORE_TYPES.PROJECT_CODE.DVR);
  }
});

export default router;
